import Vue from 'vue'
import{Calendar, Button,Row, Col, Menu, Submenu, MenuItem, MenuItemGroup, Icon,
    Table, TableColumn, Tooltip, Dropdown, DropdownMenu, DropdownItem,
    Carousel, CarouselItem, Dialog, Radio,RadioGroup, Checkbox, Tabs, TabPane,
    Form, FormItem, Input,InputNumber,OptionGroup, DatePicker, Select, Option, Tree, Upload,
    Pagination,MessageBox,Message,Cascader,CheckboxGroup,Popover,Switch,Progress,ColorPicker,Empty,Divider,Tag} from "element-ui"

const element = {
    install:function(Vue){
        Vue.use(Tag),
        Vue.use(Divider),
        Vue.use(Empty),
        Vue.use(ColorPicker),
        Vue.use(Progress),
        Vue.use(Switch),
        Vue.use(Popover),
        Vue.use(CheckboxGroup),
        Vue.use(Cascader),
        Vue.use(OptionGroup),
        Vue.use(RadioGroup),
        Vue.use(InputNumber),
        Vue.use(Button),
        Vue.use(Calendar);
        Vue.use(Row);
        Vue.use(Col);
        Vue.use(Menu);
        Vue.use(Submenu);
        Vue.use(MenuItem);
        Vue.use(MenuItemGroup);
        Vue.use(Icon);
        Vue.use(Table);
        Vue.use(TableColumn);
        Vue.use(Tooltip);
        Vue.use(Dropdown);
        Vue.use(DropdownMenu);
        Vue.use(DropdownItem);
        Vue.use(Carousel);
        Vue.use(CarouselItem);
        Vue.use(Dialog);
        Vue.use(Radio);
        Vue.use(Checkbox);
        Vue.use(Tabs);
        Vue.use(TabPane);
        Vue.use(Form);
        Vue.use(FormItem);
        Vue.use(Input);
        Vue.use(DatePicker);
        Vue.use(Select);
        Vue.use(Option);
        Vue.use(Tree);
        Vue.use(Upload)
        Vue.use(Pagination)
    }
}

Vue.prototype.$confirm = function Confirm(tip, confirmButtonText, cancelButtonText,customClass) {
  return new Promise((resolve,reject)=>{
    MessageBox.confirm(
      tip,
      "提示",
      {
        confirmButtonText:confirmButtonText|| "确定",
        cancelButtonText:cancelButtonText|| "取消",
        type: "warning",
        customClass: customClass??''
      }
    ).then((res)=>{
      resolve()
    }).catch((err)=>{ 
      reject(err)
    }) 
  })
}

const messages = ['success', 'warning', 'info', 'error'];
messages.forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = {
          message: options
      };
      if(type === 'error'){
        options.duration = 3000;
      }else{
        options.duration = 2000;
      }
      options.showClose = true;
    }
    options.type = type;
    return Message(options);
  }
})
Vue.prototype.$message = Message

export default element 